module.exports = __webpack_public_path__ + "static/media/9DESA33.2ca63300.jpg";